import React, { useEffect } from "react";
import './index.scss';

import iconDirection from '../../../img/projects/Elipse 39.svg';

import ImgOne from '../../../img/details/detailten/Img1.jpeg';
import ImgTwo from '../../../img/details/detailten/Img2.jpeg';
import ImgThree from '../../../img/details/detailten/Img3.jpg';
import ImgFour from '../../../img/details/detailten/Img4.gif';
import ImgFive from '../../../img/details/detailten/Img5.jpeg';
import ImgSix from '../../../img/details/detailten/Img6.jpeg';
import Brandin from '../../../img/details/detailten/Img7.jpeg';
import ImgEight from '../../../img/details/detailten/Img8.jpeg';
import ImgNine from '../../../img/details/detailten/Img9.jpeg';
import ImgTen from '../../../img/details/detailten/Img10.jpeg';
import ImgEleven from '../../../img/details/detailten/Img11.jpeg';
import ImgTwelve from '../../../img/details/detailten/Img12.jpeg';
import ImgTherteen from '../../../img/details/detailten/Img13.jpeg';
import ImgFourteen from '../../../img/details/detailten/Img14.jpeg';
import ImgFiveteen from '../../../img/details/detailten/Img15.jpeg';
import ImgSixteen from '../../../img/details/detailten/Img16.jpeg';
import ImgEightteen from '../../../img/details/detailten/Img17.jpeg';

import HeaderContainer from '../../header/index';
import PageSeven from '../../../views/pagesevenblack';
import ProjectNav from '../../../common/ProjectNav';

const DetailProjectTen = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const element = document.getElementById("ProjectSix");
            if (element) element.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 400);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="containerDetailSix" id="ProjectSix">
            <HeaderContainer name="normalWhite" />

            <div className="ContentProjects">
                <div className="ContentProjectsTitle">
                    <div className="ContentProjectsLeft">
                        <a href="/projects" style={{ textDecoration: "none", color: "#000" }}>
                            <img loading="lazy" src={iconDirection} alt="Our Work" />
                            Our Work
                        </a>
                    </div>
                    <div className="ContentProjectsRight">
                        We take pride in your success
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgOne} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewText">
                    <text className="title">ZOEY</text>
                    <text>
                        <label>THE BRAND</label>
                        Zoey is a European brand focused on providing high-end wigs for the discerning woman. Their products consist of natural hair with contemporary styles and maximum quality.
                        <br />
                        We aim to convey concepts such as elegance, luxury, and comfort by applying strokes and images that exude beauty and status with a European flair. Part of the challenge was presenting the brand as elegant and luxurious while maintaining a solid and memorable design.
                    </text>
                    <text>
                        <label>THE MISSION</label>
                        We decided to employ European, elegant, and organic strokes in their logo to evoke the blend of luxury and the movement of hair. The subtlety of these strokes allows for the appreciation of a modern, elegant, and dynamic image.
                        <br />
                        The applied colors express luxury and elegance with a feminine touch, paying special attention to the applications to achieve the impact the brand requires.
                    </text>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTwo} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgThree} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFour} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={Brandin} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgFive} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgSix} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgEight} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgNine} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgEleven} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTwelve} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTherteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFourteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFiveteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgSixteen} alt="" width="100%" />
                    </div>
                </div>
            </div>

            <ProjectNav current="/detailten" />
            <PageSeven />
        </div>
    );
};

export default DetailProjectTen;
